import React from 'react';
import { Form, Input, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { useForm } from 'antd/lib/form/Form';

import ThirdPartyIntegration from 'services/thirdPartyIntegrationService';
import './TingeeThirdParty.scss';
import { THIRDPARTY_CODE } from 'constants/app';
import useThirdPartyConfigForm from './hooks/useThirdPartyConfigForm';
import ThirdPartyConfigLayout from './components/ThirdPartyConfigLayout';

const VnpayInAppThirdParty = ({ id, setOpenContent, setId }) => {
  const { t: translation } = useTranslation();
  const [form] = useForm();

  const {
    loading,
    isConnected,
    hasFormChanged,
    showConfirmTest,
    setShowConfirmTest,
    handleSubmit,
    handleConfirmAndSave,
    handleValuesChange,
  } = useThirdPartyConfigForm({
    id,
    setId,
    form,
    translation,
    thirdPartyCode: THIRDPARTY_CODE.VNPAYAPP_INAPP,
    mapFromPartyRequiredData: (partyRequiredData = {}, res = {}) => ({
      aesKey: partyRequiredData?.aesKey || '',
      token: partyRequiredData?.token || '',
      serviceCode: partyRequiredData?.serviceCode || '',
      providerCode: partyRequiredData?.providerCode || '',
      preferHexKey: !!partyRequiredData?.preferHexKey,
      isEnable: res?.partyEnableStatus === 1,
    }),
    buildTestPayload: (values = {}) => ({
      aesKey: values.aesKey,
      token: values.token,
      serviceCode: values.serviceCode,
      providerCode: values.providerCode,
      preferHexKey: !!values.preferHexKey,
      amount: 10000,
    }),
    buildUpdatePayload: (values = {}, isConnectedLocal) => ({
      data: {
        partyRequiredData: {
          aesKey: values.aesKey,
          token: values.token,
          serviceCode: values.serviceCode,
          providerCode: values.providerCode,
          preferHexKey: !!values.preferHexKey,
        },
        partyActiveStatus: isConnectedLocal ? 1 : 0,
        partyEnableStatus: values.isEnable ? 1 : 0,
      },
    }),
    testApi: ThirdPartyIntegration.testConfigsVnpayInApp,
    updateApi: ThirdPartyIntegration.updateConfigsVnpayInApp,
  });

  return (
    <ThirdPartyConfigLayout
      loading={loading}
      form={form}
      translation={translation}
      title={`Cài đặt tài khoản ${translation('expand_setting.vnpay_inapp')}`}
      isConnected={isConnected}
      hasFormChanged={hasFormChanged}
      onBack={() => setOpenContent('')}
      onFinish={handleSubmit}
      onValuesChange={handleValuesChange}
      showConfirmTest={showConfirmTest}
      setShowConfirmTest={setShowConfirmTest}
      onConfirmAndSave={handleConfirmAndSave}
      confirmTitle={translation('vietqr.sendVD')}
      confirmMessage={translation('vietqr.testTransactionMessage')}
    >
      <Form.Item required label='AES Key' name='aesKey' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Token' name='token' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Service Code' name='serviceCode' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Provider Code' name='providerCode' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item label='Prefer Hex Key' name='preferHexKey' valuePropName='checked'>
        <Switch />
      </Form.Item>
    </ThirdPartyConfigLayout>
  );
};

export default VnpayInAppThirdParty;
